import React from "react";
import styles from "./direction.module.scss";

export const EventDirection = () => {
  return (
    <section>
      <div className="container">
        <div className={styles.direction_container}>
          <div>
            <h1 className={styles.heading}>Get Direction</h1>
            <div className={styles.bottom_border}></div>
            <h1 className={styles.subtitle}>Bangalore Office:</h1>
            <p className={styles.description}>
              2nd Floor, RR Image, 4th Cross, Pandurang Nagar, Bannerghatta Main
              Road, Bangalore 560076.
            </p>
          </div>
          <div className={styles.map_container}>
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3889.239332110324!2d77.59595381482117!3d12.892326290907913!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae15995d5e7861%3A0x5ab0b5664313afa5!2sUniSearch%20-%20Best%20Study%20Abroad%20Consultant%20in%20Bangalore!5e0!3m2!1sen!2sbd!4v1676270014719!5m2!1sen!2sbd"
              width="600"
              height="450"
              allowFullScreen=""
              style={{ border: "0px" }}
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
        </div>
      </div>
    </section>
  );
};

export default EventDirection;
